
<template>
  <div class="sample">
    <div class="sample-wrap demo-image__error" v-for="(item, index) in infoData" :key="index">
      <!-- <img :src="item.mainImage" @click="handlerClick(item)" /> -->
      <div class="block">
        <el-image
          style="width: 150px; height: 150px;"
          :src="item.mainImage + $ImgQuality20"
          @click="handlerClick(item)"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
      </div>
      <h3 @click="handlerClick(item)">
        {{ item.productName }}
      </h3>
      <p v-if="item.price">
        <b>¥{{ item.price }}</b
        >预估价
      </p>
      <p v-else>
        <span>价格见产品详情</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodBox',
  props: {
    name: {
      type: String,
      default: '',
    },
    pageUrl: {
      type: String,
      default: 'details-page/goods',
    },
    GoodData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      infoData: this.GoodData,
    };
  },
  watch: {
    GoodData: {
      handler(val) {
        return (this.infoData = val);
      },
    },
  },
  methods: {
    handlerClick(item) {
      const pageName = item.productName;
      const type = this.$parent.$parent.name || this.$parent.name;
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: pageName,
          href: `/${this.pageUrl}?type=${type}&id=${item.id}&productId=${item.productId || ''}&productName=${encodeURIComponent(item.productName)}`,
          isURLSearchParams: true
        },
      });
      this.$router.push({
        name: this.pageUrl,
        params: {
          name: pageName,
          id: item.id,
          productId: item.productId || '',
          productName: item.productName,
          type,
          firstCategory: item.firstCategory || ''
        },
        query: {
          id: item.id,
          productId: item.productId || '',
          productName: item.productName,
          type,
          firstCategory: item.firstCategory || ''
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.sample {
  display: flex;
  flex-wrap: wrap;
}
.sample-wrap {
  width: 200px;
  height: 265px;
  margin: 5px 15px;
  font-size: 0;
  border: 2px solid #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  &:hover {
    border-color: #AB0033;
    border-radius: 8px;
  }
  img {
    width: 200px;
    height: 200px;
    cursor: pointer;
  }
  h3 {
    font-size: 14px;
    margin: 5px;
    height: 32px;
    line-height: 16px;
    text-align: left;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    &:hover {
      text-decoration: underline;
      color: #AB0033;
      cursor: pointer;
    }
  }
  p {
    font-size: 14px;
    margin: 0 5px;
    text-align: left;
    b {
      font-size: 20px;
      color: #AB0033;
      font-weight: normal;
      margin-right: 10px;
    }
  }
}
</style>
